import { Form } from "antd";
import DataTagSelect from "containers/DataTagSelect";
import CypressTestIds from "../../../cypress/CypressTestIds";

export default ({ selectedFieldRow, readOnly, getFormErrors }) => (
    <Form.Item name={["fields", selectedFieldRow.name, "classifiers"]} label="Classifiers" {...getFormErrors(`fields.${selectedFieldRow.name}.classifiers`)}>
        <DataTagSelect disabled={readOnly} mode="multiple" placeholder="Please select classifiers" data-testid={CypressTestIds.SCHEMA_CLASSIFIERS_PROPERTY_SELECT}></DataTagSelect>
    </Form.Item>
);
